const SERVITI_TEAM_WIDGET_SCRIPT_ID = 'serviti-team-widget-script';
const SERVITI_TEAM_AGENT_ID = '732033b0-6774-4d7b-80b9-6d18a31b7c53';
const SERVITI_TEAM_WIDGET_URL = 'https://app.serviti.ai/embed/serviti-chat-widget.js';
const SERVITI_TEAM_FALLBACK_URL = `https://app.serviti.ai/chat.html?agent=${SERVITI_TEAM_AGENT_ID}`;

let supportOpenRequested = false;

export const unloadServitiTeamSupport = () => {
  supportOpenRequested = false;
  window.ServitiChat?.destroy?.();
  const script = document.getElementById(SERVITI_TEAM_WIDGET_SCRIPT_ID);
  if (!script) return;
  script.remove();
  document.querySelector('.serviti-widget-container')?.remove();
  document.querySelector('style[data-serviti-widget-styles]')?.remove();
  delete window.ServitiChat;
};

const openFallbackTab = () => {
  window.open(SERVITI_TEAM_FALLBACK_URL, '_blank', 'noopener,noreferrer');
};

const openSupportWhenReady = () => {
  let attempts = 0;
  const tryOpen = () => {
    attempts += 1;
    if (window.ServitiChat?.openSupport) {
      supportOpenRequested = false;
      window.ServitiChat.openSupport();
      return;
    }
    if (attempts >= 30) {
      supportOpenRequested = false;
      openFallbackTab();
      return;
    }
    window.setTimeout(tryOpen, 200);
  };
  tryOpen();
};

/**
 * Load the Serviti team agent only after a tenant admin asks for support.
 * The optional hidden-launcher mode means closing the panel returns the user
 * to a clean dashboard; the sidebar action is the only launcher.
 */
export const openServitiTeamSupport = ({
  tenantId,
  tenantName,
  customerName,
  customerEmail,
} = {}) => {
  if (window.ServitiChat?.openSupport) {
    window.ServitiChat.openSupport();
    return;
  }

  // Repeated clicks while the async script/config is loading should share one
  // request and open one panel, never inject duplicate widgets.
  if (supportOpenRequested) return;
  supportOpenRequested = true;

  const existingScript = document.getElementById(SERVITI_TEAM_WIDGET_SCRIPT_ID);
  if (existingScript) {
    openSupportWhenReady();
    return;
  }

  const script = document.createElement('script');
  script.id = SERVITI_TEAM_WIDGET_SCRIPT_ID;
  script.src = SERVITI_TEAM_WIDGET_URL;
  script.async = true;
  script.setAttribute('data-agent-id', SERVITI_TEAM_AGENT_ID);
  script.setAttribute('data-position', 'right');
  script.setAttribute('data-theme', 'light');
  script.setAttribute('data-auto-open', 'false');
  script.setAttribute('data-hide-launcher', 'true');
  // TenantLayout has a fixed 64px mobile tab bar. Automatic host-control
  // detection handles it; this 8px-gapped floor also protects the controls
  // while the layout is mounting or changing routes.
  script.setAttribute('data-mobile-bottom-offset', '72');
  script.setAttribute('data-customer-tenant-id', tenantId || '');
  script.setAttribute('data-customer-tenant-name', tenantName || 'Tenant workspace');
  script.setAttribute('data-customer-name', customerName || 'Tenant admin');
  script.setAttribute('data-customer-email', customerEmail || '');
  script.setAttribute('data-support-entry', 'tenant-admin-sidebar');
  script.addEventListener('load', openSupportWhenReady, { once: true });
  script.addEventListener('error', () => {
    supportOpenRequested = false;
    script.remove();
    openFallbackTab();
  }, { once: true });
  document.body.appendChild(script);
};
